<div
  #chatBox
  #dragRef="cdkDrag"
  coinResizable
  class="chat-dialog"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  animate.enter="fade-in"
  animate.leave="fade-out"
  [drag]="dragRef"
  [cdkDragConstrainPosition]="constrainPosition"
  [tabIndex]="-1">
  <!-- Flying bat animation - Halloween theme -->
  @if (showBatAnimation()) {
    <div class="flying-bat"></div>
  }

  <coin-chat-dialog-header
    cdkDragHandle
    [title]="'chat-bot.window.title' | translate"
    [isFaqActive]="isFaqScreenActive()"
    (closePress)="closeChat()"
    (faqPress)="toggleFaq()"></coin-chat-dialog-header>

  <coin-chat-dialog-content>
    @if (isFaqScreenActive()) {
      <coin-chat-faq-screen (backPress)="toggleFaq()" />
    } @else {
      @for (message of messages(); track $index) {
        <coin-chat-message
          [message]="message"
          [gid]="user()?.gid"
          (download)="downloadFile($event)"></coin-chat-message>
      } @empty {
        <coin-chat-start-view
          [name]="user()?.firstName"
          [prompts]="prompts()"
          [newPromptLabel]="'chat-bot.actions.another-suggestion' | translate"
          (promptSelected)="sendMessage($event)" />
      }
    }
  </coin-chat-dialog-content>

  @if (!isFaqScreenActive()) {
    <coin-chat-dialog-footer
      [disableSendButton]="isSendButtonDisabled()"
      [disableCleanButton]="messages().length === 0 || hasPendingMessages()"
      (cleanMessage)="cleanMessages()"
      (sendMessage)="sendMessage($event)"></coin-chat-dialog-footer>
  }

  <!-- Resize handles -->
  <div
    class="resize-handle bottom-right"
    data-direction="bottom-right">
    <mat-icon>filter_list</mat-icon>
  </div>

  <!-- Snowfall animation - Winter theme (placed last to control z-index) -->
  @if (showSnowAnimation()) {
    <div class="snowfall-container">
      @for (flake of snowflakes(); track flake.id) {
        <div
          class="snowflake-wrapper"
          [style.left.%]="flake.x"
          [style.animation-duration.s]="flake.duration"
          [style.animation-delay.s]="flake.delay">
          <coin-snowflake
            [size]="flake.size"
            [variant]="flake.variant" />
        </div>
      }
    </div>
  }
</div>
